import * as React from 'react';
import b_ from 'b_';

import './index.scss';

interface Props {
  url: string;
  name: string;
  big?: boolean;
  mid?: boolean;
}

interface State {
  url?: string;
  error: boolean;
}

const b = b_.with('stock-icon');

class StockIcon extends React.Component<Props, State> {
  state: State = {
    error: false,
  };

  render() {
    const { big, mid } = this.props;
    const { url, error } = this.state;

    if (error) {
      return <div className={b('', { fallback: true, big: !!big })}>{this.getSymbols()}</div>;
    }

    return (
      <img
        className={b('', { mid: !!mid, big: !!big })}
        src={url}
        onError={() => this.setState({ error: true })}
      />
    );
  }

  private getSymbols() {
    return this.props.name
      .split(' ')
      .map((part) => part && part.charAt(0))
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  // Do not set img.src directly, wait for img.onError binding
  // otherwise 404 error will be not catched in some cases
  componentDidMount() {
    this.setState({ url: this.props.url });
  }
}

export default StockIcon;
